import React, { FC } from 'react';
import { TimePicker } from 'antd';
import Form, { FormComponentProps } from 'antd/lib/form';
import { ValidateQuestionnaire, Question } from './QuestionnaireForm';
import moment from 'moment';

interface Props extends FormComponentProps {
  question: Question;
  validator: ValidateQuestionnaire;
}

export const QuestionTime: FC<Props> = ({ form, question, validator }): JSX.Element => (
  <Form.Item label={question.text} key={question.id} extra={question.helpText}>
    {form.getFieldDecorator(`questionnaire[0].${question.id}-time`, {
      rules: [{ required: question.required, message: 'required' }, { validator: validator }],
      initialValue: question.initialValue,
    })(<TimePicker use12Hours minuteStep={5} format="h:mm a" defaultOpenValue={moment('9:00 a', 'h:mm a')} />)}
  </Form.Item>
);
